import { render, staticRenderFns } from "./StructureSkillChange.vue?vue&type=template&id=0727be58&scoped=true"
import script from "./StructureSkillChange.vue?vue&type=script&lang=ts"
export * from "./StructureSkillChange.vue?vue&type=script&lang=ts"
import style0 from "./StructureSkillChange.vue?vue&type=style&index=0&id=0727be58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0727be58",
  null
  
)

export default component.exports